import React from 'react';
import decklepro_img from '../images/decklepro.png'; // Use your product image here
import { useNavigate } from 'react-router-dom';

const Product = () => {
    const navigate = useNavigate();

    const handleCardClick = () => {
        navigate('/product-details');
    };

    return (
        <section id="product" className="product-section py-5">
            <div className="container" data-aos="fade-up">
                {/* Header */}
                <div className="text-center mb-5">
                    <h2 className="section-title fw-bold">Our Product</h2>
                    <p className="section-subtitle text-muted">
                        Innovation meets efficiency explore our flagship SaaS solution designed to optimize industrial operations.
                    </p>
                </div>

                {/* Product Card */}
                <div className="row justify-content-center">
                    <div className="col-lg-5 col-md-6">
                        <div
                            className="product-card text-center p-5 shadow-sm"
                            style={{ cursor: 'pointer' }}
                            onClick={handleCardClick}
                            id="decklepro"
                        >
                            <div className="product-img mb-4">
                                <img alt="DecklePro" height={130} width={160} src={decklepro_img} />
                            </div>
                            <h2>
                                <span style={{ color: '#165b90' }}>Deckle</span>
                                <span style={{ color: '#7aa056' }}>Pro</span>
                            </h2>
                            <p className="text-muted mb-0">
                                Smart Deckle Matching Software for the Paper Mill Industry.<br />
                                Reduce trim waste, optimize production, and manage your entire operation efficiently on one platform.
                            </p>
                            <div className="mt-4">
                                <button className="btn btn-gradient btn-lg rounded-pill shadow-sm">
                                    Learn More
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Product;